module.exports = require("d3-scale-chromatic");